import {Injectable} from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Router,
  RouterStateSnapshot
} from '@angular/router'
import {from, Observable} from "rxjs";
import {AuthService} from "../services/auth/auth.service";

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

  private router: Router;
  private authService: AuthService;

  constructor(router: Router, authService: AuthService) {
    this.router = router;
    this.authService = authService;
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>  {
    return from(this.isAuthenticated());
  }

  canActivateChild(): Observable<boolean> {
    return from(this.isAuthenticated());
  }

  canLoad(): Observable<boolean> {
    return from(this.isAuthenticated());
  }

  private async isAuthenticated(): Promise<boolean> {
    if (!(await this.authService.hasStoredSession())) {
      await this.authService.logout401();
      return false;
    }
    return this.authService.ensureValidSession();
  }
}
